import React from 'react';
import { Icon, IconButton } from '@material-ui/core';
import css from './index.module.scss';
import cross from './images/cross.svg';
import { AiOutlineLeft } from '@react-icons/all-files/ai/AiOutlineLeft';

function BackButton({ handleBack, type }) {
  return (
    <IconButton className={css.backButton} onClick={handleBack}>
      {type == 'cross' ? (
        <img src={cross} />
      ) : (
        <AiOutlineLeft size={24} className={css.styleIcon} />
      )}
    </IconButton>
  );
}

export default BackButton;
